class Pagina {
    constructor(
        public key: number,
        public id: number,
        public nom: string,
        public tipus: number,
        public extensio: string,
        public pantalla: string,
        public contenedor: string,
        public descripcio: string,
        public subpagines: string,
        public visible: number,
    ) {}
}

// Instancia por defecto para una página
const defaultPagina: Pagina = {
    key: 0,
    id: 0,
    visible: 0,
    nom: "",
    tipus: 0,
    extensio: "",
    pantalla: "",
    contenedor: "",
    descripcio: "",
    subpagines: "",
};
export { Pagina, defaultPagina };
